export enum COMMUNITY_TYPE {
  PUBLIC = 1,
  OPEN = 2,
  EXCLUSIVE = 3,
  PRODUCT = 4
}

export const HOT_FEATURE_COMMUNITY_CONSUME_ID = 46

export const EDIT_COMMUNITY_SUCCESS = 'EDIT_COMMUNITY_SUCCESS'
